import CircleXSvg from '@assets/images/svg/circle-x.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleXIconProps {
    size?: number;
    color?: string;
}

export function CircleXIcon({ size = 24, color = '#D8181E' }: CircleXIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleXSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CircleXIcon;
